import { css } from "@emotion/react";
import React from "react";
import Lottie from "lottie-react";
import loading from "@src/assets/Loading.json";
import AiBottomSheetItem from "@src/components/aiFilter/AiBottomSheetItem";
import { transferToNative } from "@src/lib/WebAppBridge";
import { IFavoriteRegionList } from "../service/api";

interface Props {
    contentRef: React.RefObject<HTMLDivElement | null>;
    data?: IFavoriteRegionList | null;
    isFetching: boolean;
}

const FavoriteRegionItemList = ({ contentRef, data, isFetching }: Props) => {
    const isLoadingFirst = isFetching && !data;

    return (
        <>
            <div ref={contentRef as React.RefObject<HTMLDivElement>} css={rootBoxStyle}>
                {isLoadingFirst ? (
                    <div css={loadingCenterStyle}>
                        <Lottie className="lottie" animationData={loading} loop style={{ width: 80, height: 80 }} />
                        <span css={loadingTextStyle}>매물을 불러오는 중입니다</span>
                    </div>
                ) : data ? (
                    <div css={listBoxStyle}>
                        {data.totalCount === 0 ? (
                            <div css={noDataBoxStyle}>조건에 맞는 매물이 없습니다.</div>
                        ) : (
                            data.list?.map((item: any) => (
                                <AiBottomSheetItem
                                    onClick={() =>
                                        transferToNative(
                                            JSON.stringify({ item_id: item.itemId, bid_type: item.bidType }),
                                            "onClickItem",
                                        )
                                    }
                                    key={item.itemId ?? item.subId}
                                    item={item}
                                />
                            ))
                        )}
                    </div>
                ) : null}
                {isFetching && data && (
                    <div css={lottieBoxStyle}>
                        <Lottie className="lottie" animationData={loading} style={{ width: 48, height: 48 }} />
                    </div>
                )}
            </div>
        </>
    );
};

export default FavoriteRegionItemList;

const rootBoxStyle = css`
    overflow: hidden auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 14px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
    height: calc(100dvh - 170px);
`;

const listBoxStyle = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

const noDataBoxStyle = css`
    padding: 40px 0;
    text-align: center;
    font-size: 14px;
    color: #666;
`;

const loadingCenterStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 200px;
    padding: 40px 0;
`;

const loadingTextStyle = css`
    font-size: 14px;
    color: #666;
`;

const lottieBoxStyle = css`
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .lottie {
        flex-shrink: 0;
    }
`;
